<template>
  <div class="d-flex align-center justify-center">
    <v-tooltip bottom max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" small @click="copyToClipBoard" icon
          ><v-icon small>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>
<script lang="ts">
import FSnackbar from "@/fsnackbar";
import Helper from "@/util/Helper";

import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";

@Component({
  components: {},
})
export default class FCellCopy extends ModelVue {
  @Prop()
  dataSelectorKeyToCopy: string;

  @Prop()
  dataSelectorKey: string;

  @Prop({
    default: "Click here to copy",
  })
  tooltipText: string;

  @Prop()
  onClick: (item: any) => any;

  copyToClipBoard() {
    const textToCopy = this.dataSelectorKeyToCopy
      ? this.selectModel(this.modelValue,this.dataSelectorKeyToCopy)
      : this.selectModel(this.modelValue,this.dataSelectorKey)
    
    if (textToCopy) {
      Helper.copyToClipBoard(textToCopy);
    } else if (this.onClick) {
      this.onClick(this.modelValue);
    }
  }
}
</script>
